<template>
  <div class="personaledit">
    <div class="bu_zhou">
      <el-steps :active="active" finish-status="success" v-show="ctype == 0">
        <el-step></el-step>
        <el-step></el-step>
      </el-steps>
    </div>
    <!-- 第一步上传身份证 -->
    <div v-show="active == 0 && ctype == 0">
      <div class="flex-center title">请上传身份证人像面</div>
      <div class="flex-center">
        <el-upload
          class="upload-demo"
          drag
          :action="burl + '/api/v1/upload'"
          multiple
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload1"
          v-loading="loading1"
        >
          <div v-if="!data.idcardFront">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将身份证人面像拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">大小不能超过20M</div>
          </div>
          <img v-if="data.idcardFront" :src="data.idcardFront" class="avatar" />
        </el-upload>
      </div>
      <div class="flex-center title" style="margin-top: 24px">
        请上传身份证国徽面
      </div>
      <div class="flex-center">
        <el-upload
          class="upload-demo"
          drag
          :action="burl + '/api/v1/upload'"
          multiple
          :show-file-list="false"
          :on-success="handleAvatarSuccess1"
          :before-upload="beforeAvatarUpload2"
          v-loading="loading2"
        >
          <div v-if="!data.idcardBack">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将身份证国徽面拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">大小不能超过20M</div>
          </div>
          <img v-if="data.idcardBack" :src="data.idcardBack" class="avatar" />
        </el-upload>
      </div>
    </div>

    <!-- 第二部校正信息 -->
    <div v-show="active == 1 || ctype == 1">
      <div class="flex-center title">补全个人信息</div>

      <el-descriptions class="margin-top" :column="1" border>
        <el-descriptions-item v-if="ctype == 1">
          <template slot="label"> 证件正面上传 </template>
          <el-upload
            class="upload-demo"
            drag
            :action="burl + '/api/v1/upload'"
            multiple
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload1"
            v-loading="loading1"
          >
            <div v-if="!data.idcardFront">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将证件正面拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">大小不能超过20M</div>
            </div>
            <img
              v-if="data.idcardFront"
              :src="data.idcardFront"
              class="avatar"
            />
          </el-upload>
        </el-descriptions-item>

        <el-descriptions-item v-if="ctype == 1">
          <template slot="label"> 证件反面上传 </template>
          <el-upload
            class="upload-demo"
            drag
            :action="burl + '/api/v1/upload'"
            multiple
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
            :before-upload="beforeAvatarUpload2"
            v-loading="loading2"
          >
            <div v-if="!data.idcardBack">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将证件反面拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">大小不能超过20M</div>
            </div>
            <img v-if="data.idcardBack" :src="data.idcardBack" class="avatar" />
          </el-upload>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 姓名 </template>
          <input
            type="text"
            v-model="data.name"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 身份证号 </template>
          <input
            type="text"
            v-model="data.idcardNumber"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 生日 </template>
          <el-date-picker
            v-model="data.birthday"
            type="date"
            placeholder="选择日期时间"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 性别 </template>
          <el-radio v-model="data.sex" label="男">男</el-radio>
          <el-radio v-model="data.sex" label="女">女</el-radio>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 民族 </template>
          <input
            type="text"
            v-model="data.nation"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 住址 </template>
          <input
            type="text"
            v-model="data.address"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 身份证有效期 </template>
          <el-date-picker
            v-model="data.invalidTime"
            type="date"
            placeholder="选择日期时间"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-descriptions-item>

        <!-- 没对参数的 -->
        <el-descriptions-item>
          <template slot="label"> 联系电话 </template>
          <input
            type="text"
            v-model="data.phone"
            style="width: 100%; outline: none"
            :maxlength="11"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            {{ ctype == 0 ? "省/市/县(区)" : "国外" }}
          </template>
          <el-cascader
            v-model="cascaderValue"
            :options="options"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange"
          ></el-cascader>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 通讯地址 </template>
          <input
            type="text"
            v-model="data.actualAddress"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label"> 邮箱 </template>
          <input
            type="text"
            v-model="data.email"
            style="width: 100%; outline: none"
          />
        </el-descriptions-item>
      </el-descriptions>
      <div class="ti_shi flex-center">
        请仔细检查识别信息,如果有误,请重新拍照上传
      </div>
    </div>

    <div class="flex-center buttons">
      <el-button
        type="primary"
        round
        @click="back"
        v-show="active != 0 && ctype == 0"
      >
        上一步
      </el-button>
      <el-button
        type="primary"
        :loading="next1"
        round
        @click="next"
        v-show="active != 1 && ctype == 0"
      >
        下一步
      </el-button>
      <el-button
        type="primary"
        round
        @click="submit"
        v-show="active == 1 || ctype == 1"
      >
        确认提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { getRequest, postRequest } from "../api/api";
import { baseUrl } from "../api/constant";
import { options, enOptions } from "../api/region";
export default {
  data() {
    return {
      active: 0, //步骤条
      data: {
        idcardNumber: null,
        phone: null,
        email: null,
      },
      id: null,
      idcardBack: null,
      idcardFront: null,
      loading1: false,
      loading2: false,
      next1: false,
      cascaderValue: [],
    };
  },
  props: {
    ctype: {
      type: Number,
      default(n) {
        return n;
      },
      required: true,
    },
  },
  watch: {
    ctype(n) {
      this.data = {};
    },
  },
  computed: {
    burl() {
      return baseUrl;
    },
    options() {
      if (this.ctype == 1) {
        return enOptions;
      } else if (this.ctype == 0) {
        return options;
      } else {
        return [];
      }
    },
  },
  methods: {
    // 触发省/市/县(区)选择切换
    handleChange(n) {
      this.data.regionName = n.join("/");
    },
    initial() {
      this.active = 0;
    },
    // 下一步
    next() {
      this.next1 = true;
      let data = {
        idcardBack: this.data.idcardBack,
        idcardFront: this.data.idcardFront,
      };
      postRequest({ url: "/api/v1/auth/idcard", data })
        .then((res) => {
          if (res.errcode == 200) {
            // this.data = { ...this.data, ...res.data };
            this.data = res.data;
            this.active++;
          } else {
            this.$message.error(res.errmsg);
          }
          this.next1 = false;
        })
        .catch((err) => [(this.next1 = false)]);
    },
    // 上一步
    back() {
      this.active--;
    },
    // 效验
    validate() {
      // 当前为境外授权时跳过所有效验
      if (this.ctype == 1) return true;
      // 身份证效验
      let reg =
        /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
      if (!reg.test(this.data.idcardNumber)) {
        this.$message.error("身份证格式有误");
        return false;
      }
      // 手机号效验
      let reg1 = /^1[3456789]\d{9}$/;
      if (!reg1.test(this.data.phone)) {
        this.$message.error("手机号格式有误");
        return false;
      }
      // 邮箱效验
      let reg2 = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!reg2.test(this.data.email)) {
        this.$message.error("邮箱格式有误");
        return false;
      }
      return true;
    },
    // 提交信息
    submit() {
      // console.log("效验结果", this.data);
      // return;

      let xiaoYan = this.validate();
      if (!xiaoYan) return;

      let data = this.data;

      if (this.ctype == 0) {
        data.region = "境内";
      } else if (this.ctype == 1) {
        data.region = "境外";
      }

      data.idcardBack = this.idcardBack;
      data.idcardFront = this.idcardFront;
      postRequest({ url: "/api/v1/auth/person/create", data }).then((res) => {
        if (res.errcode == 200) {
          this.$message.success("认证提交成功,请等待审核");
          this.$emit("close");
          this.active = 0;
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    // 照片上传-------------------------
    handleAvatarSuccess(res, file) {
      this.data.idcardFront = res.data.webPath;
      this.idcardFront = res.data.webPath;
      this.loading1 = false;
    },
    handleAvatarSuccess1(res, file) {
      this.data.idcardBack = res.data.webPath;
      this.idcardBack = res.data.webPath;
      this.loading2 = false;
    },
    beforeAvatarUpload1(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 20;

      // 上传中提示
      this.loading1 = true;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        this.loading1 = false;
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    beforeAvatarUpload2(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 20;

      // 上传中提示
      this.loading2 = true;

      // if (!isJPG) {
      //   this.$message.error("上传图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
        this.loading2 = false;
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    // ------------------------------------
  },
};
</script>

<style lang="scss">
.personaledit {
  padding: 0 20%;
  .ti_shi {
    color: red;
    font-size: 14px;
    margin-top: 12px;
  }
  .buttons {
    margin-top: 24px;
    .el-button.is-round {
      padding: 12px 70px;
    }
  }
  .bu_zhou {
    width: 300px;
    margin: 0 auto;
    margin-bottom: 36px;
  }
  .title {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 600;
  }
  // 照片设置----------------------------------
  .avatar {
    width: 100%;
    height: 178px;
    display: block;
  }
  // ---------------------------------------------
}
</style>
